import { render, staticRenderFns } from "./electronic-forms-dialog.vue?vue&type=template&id=1bbe64ae&"
import script from "./electronic-forms-dialog.vue?vue&type=script&lang=js&"
export * from "./electronic-forms-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports